import React, { useEffect, useState } from 'react';
import {
  IonToast,
  IonIcon,
} from '@ionic/react';
import {
  checkmarkCircleOutline,
} from 'ionicons/icons';
import { eventBus, EVENTS } from '../utils/eventBus';

interface FulfillmentNotificationProps {}

const FulfillmentNotification: React.FC<FulfillmentNotificationProps> = () => {
  const [showToast, setShowToast] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const unsubscribe = eventBus.on(EVENTS.SALES_FULFILLED, (data: { count: number; ticketsUsed: number }) => {
      setMessage(
        `${data.count} sale${data.count > 1 ? 's' : ''} automatically fulfilled using ${data.ticketsUsed} ticket${data.ticketsUsed > 1 ? 's' : ''} from new inventory!`
      );
      setShowToast(true);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <IonToast
      isOpen={showToast}
      onDidDismiss={() => setShowToast(false)}
      message={message}
      duration={5000}
      position="top"
      color="success"
      icon={checkmarkCircleOutline}
      buttons={[
        {
          text: 'Dismiss',
          role: 'cancel',
        },
      ]}
    />
  );
};

export default FulfillmentNotification;